import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Disable browser scroll restoration so the app controls scroll position on
// every visit — prevents the page from opening mid-scroll on return visits.
if (typeof history !== "undefined") {
  history.scrollRestoration = "manual";
}

// Self-heal stale lazy chunks after a deploy. When we republish, index.html points at new
// hashed chunk filenames; a tab that was already open (or served a cached index) requests an
// old chunk that no longer exists, and the dynamic import 404s. Vite fires vite:preloadError
// for exactly this. Reload once to fetch the fresh index + correct chunks. The sessionStorage
// guard prevents a reload loop if the failure is not actually a stale-chunk issue.
if (typeof window !== "undefined") {
  window.addEventListener("vite:preloadError", () => {
    if (!sessionStorage.getItem("vro_chunk_reloaded")) {
      sessionStorage.setItem("vro_chunk_reloaded", "1");
      window.location.reload();
    }
  });
  // Clear the guard once a load fully succeeds so a future deploy can self-heal again.
  window.addEventListener("load", () => {
    setTimeout(() => sessionStorage.removeItem("vro_chunk_reloaded"), 5000);
  });
}

const rootElement = document.getElementById("root")!;

if (rootElement.dataset.ssr === "true") {
  hydrateRoot(rootElement, <App />);
} else {
  createRoot(rootElement).render(<App />);
}
